import base from '../dr-base'
import drDropDown from './dr-drop-down.vue'
import drBaseActions from '../dr-base-actions'

const schema = {
  $Type: 'dr-drop-down',
  name: 'Drop down',
  group: 'Input widgets',
  icon: 'caret-square-down',
  ...base,
  properties: {
    ...base.properties,
    Disabled: {
      name: 'vuetifyWidgets.dr-drop-down.disabled',
      type: 'string',
      default: ''
    },
    Required: {
      name: 'vuetifyWidgets.general.required',
      type: 'boolean'
    },
    Caption: {
      name: 'vuetifyWidgets.dr-drop-down.caption',
      type: 'string',
      default: ''
    },
    Value: {
      name: 'vuetifyWidgets.dr-drop-down.value',
      type: 'string',
      default: '',
      component: 'dr-value-editor'
    },
    Items: {
      name: 'vuetifyWidgets.dr-drop-down.items',
      type: 'string',
      default: '',
      component: 'dr-value-editor'
    },
    Style: {
      name: 'vuetifyWidgets.dr-drop-down.style',
      type: 'string',
      default: 'regular',
      enum: [{
        value: 'regular',
        text: 'Regular'
      }, {
        value: 'solo',
        text: 'Solo'
      }, {
        value: 'filled',
        text: 'Filled'
      }, {
        value: 'outlined',
        text: 'Outlined'
      }]
    },
    GenerationOnChange: {
      ...drBaseActions.properties.OnClickAction,
      name: 'vuetifyWidgets.dr-drop-down.generationOnChange'
    }
  }
}

export default {
  schema,
  component: drDropDown,
  propEditors: [
    {
      name: 'dr-prop-action'
    }
  ]
}
